import {FC} from 'react'

import {FormRadioButton} from '@/components/inputs/FormRadioButton'
import {useCommonContent} from '@/content/common'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

import {useAssignmentAgreement} from './context/AssignmentAgreementContext'

type PricingAssignmentAgreementRadioButtonsProps = {
  size?: 'small' | 'medium'
}

export const PricingAssignmentAgreementRadioButtons: FC<
  PricingAssignmentAgreementRadioButtonsProps
> = ({size = 'medium'}) => {
  const {t} = useTranslation()
  const {optionYes, optionNo} = useCommonContent()
  const {hasAssignmentAgreement, setHasAssignmentAgreement} = useAssignmentAgreement()

  return (
    <>
      <div className="wrapper">
        <div className="item">
          <FormRadioButton
            title={t(optionYes)}
            isSelected={hasAssignmentAgreement === true}
            onChange={() => setHasAssignmentAgreement(true)}
            isSubmitting={false}
            size={size}
          />
        </div>
        <div className="item">
          <FormRadioButton
            title={t(optionNo)}
            isSelected={hasAssignmentAgreement === false}
            onChange={() => setHasAssignmentAgreement(false)}
            isSubmitting={false}
            size={size}
          />
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          gap: ${size === 'small' ? theme.spacing[2.5] : theme.spacing[3]};
        }
        .item {
          flex: 1;
        }
      `}</style>
    </>
  )
}
